import queryString from 'query-string';

import * as types from './types';

function isLocalStorageEnabled() {
  try {
    const mod = '__storage_test__';
    localStorage.setItem(mod, mod);
    localStorage.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

function appSetDataSuccess(data) {
  return {
    type: types.APP_SET_DATA,
    payload: {
      data,
    },
  };
}

export function appSetData() {
  return (dispatch) => {
    const query = queryString.parse(window.location.search);
    const appData = {};
    const dataList = ['companyID', 'companyName', 'projectID', 'projectName', 'sms'];
    let newValues = false;
    dataList.forEach((key) => {
      const value = query[key];
      if (value) {
        newValues = true;
        appData[key] = value;
      }
    });
    const isLocalStorage = isLocalStorageEnabled();
    if (newValues && isLocalStorage) {
      dataList.forEach((key) => {
        localStorage.setItem(`appData:${key}`, appData[key] || '');
      });
    }

    if (isLocalStorage) {
      dataList.forEach((key) => {
        const item = localStorage.getItem(`appData:${key}`);
        appData[key] = item;
      });
    }

    dispatch(appSetDataSuccess(appData));
  };
}



// WEBPACK FOOTER //
// ./src/redux/app/actions.js